import {SET_BAG_MERCHANDISE_INFO} from 'od-modules/secure_store/actions';

export default function ancillariesInformation(state = {}, action) {
    switch (action.type) {
        case SET_BAG_MERCHANDISE_INFO:
            return Object.assign({}, state, {merchandisingDiscount: action.entry});
        default:
            return state;
    }
}
